const routes = {
  getClientDropdown: "clients/dropdown",
  getClientCosting: "clients/costings",
  getClientCostingV2: "clients/costings-v2",
  getClientCostingSoa: "clients/costings-soa",
  getClientCostingSoaV1: "clients/costings-soa-v1",
  updateClientCosting: "clients/costings/update",
  updateClientCostingV2: "clients/costings/update/v2",
  removeClientCosting: "clients/costings/remove",
  getClientVin: "shippings/filters",
  getStorageDetails: "clients/storage/details",
  getAllStorageDetails: "clients/storage/getDetails",
  updateStorage: "clients/storage/update",
  getTTVin: "clients/vehicleTT/vehicles",
  getVehicleTT: "vehicleBookings/vinDetails",
  getBuyerId: "buyerIds",
  AddTT: "clients/vehicleTT/plan/add",
  updateTT: "clients/vehicleTT/plan/edit",
  getTT: "clients/vehicleTT",
  getTTDetail: "clients/vehicleTT/details",
  getClientRates: "clients/importRates",
  updateRates: "clients/importRates/update",
  updateFundsApply: "clients/funds/apply",
  updateFundsApplyV2: "clients/funds/apply/v2",
  getAppliedFunds: "clients/funds",
  getVehicleTTPreview: "clients/vehicleTT/preview",
  getClientInvoice: "clients/invoice/details",
  getClientInvoicePreview: "clients/invoice/preview",
  uploadClientRate: "/clients/importRates/upload",
  getShippingInvoice: "clients/funds/details",
  sendApproval: "clients//vehicleTT/approvals/send",
  getApprovalList: "clients/vehicleTT/approvals",
  approveTTStatus: "clients/vehicleTT/approvals/update",
  getVehicleForTT: "vehicleBookings/tt/availableVehicles",
  deleteTT: "clients/vehicleTT/delete",
  getShippingInvoicePreview: "clients/funds/preview",
  deleteCostingEntries: "clients/costings/delete",
  reverseCostingEntries: "clients/reverse/invoice",
  getAllSLP: "clients/storage/all",
  deleteStorage: "clients/storage/delete",
  getPrepaidauction: "prepaid-slp/vehicles",
  getPrepaidAuction: "prepaid-slp",
  bookPrepaidAuction: "prepaid-slp",
  updatePrepaidauction: "prepaid-slp/update",
  prepaidauctionDetails: "prepaid-slp/details",
  deleteprepaidauction: "prepaid-slp/delete",
  specialDiscount: "special-discount",
  specialDiscountList: "special-discount",
  specialDiscountDetails: "special-discount/detail",
  updateSpecialDiscount: "special-discount/",
  deleteSpecialDiscount: "special-discount/delete",
  getClientInvoiceList: "clients/invoice/details/list",
};

export default routes;
